export default __webpack_public_path__ + "static/hero-f3b59fa1326aa9eaa7c1f2a4044f841a.png";